module.exports = __webpack_public_path__ + "img/lp_swish_140x120.498100c9.gif";